import { DotLegalCheckbox, DotLegalDialog, DotLegalHeader, GridSizes } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import useFullDataExportDialogHooks from "./FullDataExportDialog.hooks";

export interface IFullDataExportDialogProps {
    onDialogClose: () => void;
}

function FullDataExportDialog(props: IFullDataExportDialogProps) {
    const { translateString } = useTranslation();
    const { exportModel, modelUpdater, allSelected, triggerExport, exportButtonEnabled, inProgress } = useFullDataExportDialogHooks(props);

    const gridSizes: GridSizes = {
        sm: 12,
        md: 6,
    };

    return (
        <DotLegalDialog
            okButtonDisabled={!exportButtonEnabled}
            size="sm"
            header={translateString("fullDataExportHeader")}
            buttonOkText={translateString("export")}
            open
            onDialogClose={() => props.onDialogClose()}
            onOkClick={() => triggerExport()}
            inProgress={inProgress}
            disableBackdropOnCloseIfValueChange={exportModel}
        >
            <Box sx={{ marginLeft: 2, marginRight: 2 }}>
                <DotLegalHeader center fontWeight={0} headerStyle={"small"}>
                    {translateString("fullDataExportDescription")}
                </DotLegalHeader>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Box>
                        <Box sx={{ marginBottom: 1 }}>
                            <DotLegalCheckbox onChange={() => modelUpdater.toggleAll()} checked={allSelected} label={translateString("selectAll")} />
                        </Box>
                        <Grid container>
                            <Grid size={{ ...gridSizes }}>
                                <DotLegalCheckbox
                                    onChange={(checked) => modelUpdater.onProcessingActivitiesChange(checked)}
                                    checked={exportModel.processingActivities}
                                    label={translateString("processingActivities")}
                                />
                            </Grid>
                            <Grid size={{ ...gridSizes }}>
                                <DotLegalCheckbox
                                    onChange={(checked) => modelUpdater.onSystemsChange(checked)}
                                    checked={exportModel.systems}
                                    label={translateString("systems")}
                                />
                            </Grid>
                            <Grid size={{ ...gridSizes }}>
                                <DotLegalCheckbox
                                    onChange={(checked) => modelUpdater.onLegalEntitiesChange(checked)}
                                    checked={exportModel.legalEntities}
                                    label={translateString("legalEntities")}
                                />
                            </Grid>
                            <Grid size={{ ...gridSizes }}>
                                <DotLegalCheckbox
                                    onChange={(checked) => modelUpdater.onContractsChange(checked)}
                                    checked={exportModel.contracts}
                                    label={translateString("contracts")}
                                />
                            </Grid>
                            <Grid size={{ ...gridSizes }}>
                                <DotLegalCheckbox
                                    onChange={(checked) => modelUpdater.onPoliciesChange(checked)}
                                    checked={exportModel.policies}
                                    label={translateString("policies")}
                                />
                            </Grid>
                            <Grid size={{ ...gridSizes }}>
                                <DotLegalCheckbox
                                    onChange={(checked) => modelUpdater.onDocumentsChange(checked)}
                                    checked={exportModel.documents}
                                    label={translateString("documents")}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </DotLegalDialog>
    );
}

export default FullDataExportDialog;
